export const IP_TYPE = {
    DHCP: 'dhcp',
    STATIC: 'static',
    STATIC_POOL_MANUAL: 'static_ip_pool_manual',
};

export const MODE = {
    APPLIANCE: 'appliance',
    DESTINATION: 'destination',
    PROFILE: 'profile',
};

export const NIC_TYPE_ETHERNET = 'Ethernet';
export const AZURE_LOCAL_CIDR_FIELDS = ['netmask', 'primary_dns', 'secondary_dns'];
